import React from 'react';
import { Embed } from 'semantic-ui-react';
var EmbedWrapper = function EmbedWrapper(_ref) {
  var active = _ref.active,
    url = _ref.url;
  return /*#__PURE__*/React.createElement(Embed, {
    active: active,
    url: url
  });
};
EmbedWrapper.defaultProps = {
  active: false
};
export default EmbedWrapper;